import { memo } from "react";
import { Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";

const Button = (props) => {
  const {
    onClick = () => {},
    text = "",
    className = "",
    style = {},
    to = "",
    nosite = false,
    disabled = false,
    loading = false,
  } = props;

  let class_name = `${!nosite ? "site-btn" : ""} ${className}`;

  if (to && to !== "") {
    return (
      <Link className={class_name} to={to}>
        {text}
      </Link>
    );
  }

  return (
    <button
      disabled={disabled || loading}
      style={style}
      className={class_name}
      onClick={onClick}
    >
      {loading ? (
        <span className="d-inline-flex align-items-center gap-2">
          <Spinner animation="border" size="sm" />
          <span>{text || "Loading..."}</span>
        </span>
      ) : (
        text
      )}
    </button>
  );
};

export default memo(Button);
